import React from 'react';

import { faqData } from '../ElevatedLandingPage/constants';
import FAQ from './FAQ';

/**
 * Standalone FAQ page for authenticated users (Header + FAQ + Footer via PageLayout).
 */
const FAQsPage = () => {
  return (
    <section className="flex justify-center md:items-center px-1 py-5 md:px-50 md:py-15 relative z-20 min-h-[60vh] bg-soft-blue">
      <FAQ data={faqData} />
    </section>
  );
};

export default FAQsPage;
